export const FIRM_SIZES = ["Just me", "2 to 4", "5 to 10", "11 to 20", "21+"]

export const PRIMARY_SERVICE_OPTIONS = [
  { label: "Bookkeeping", value: "bookkeeping" },
  { label: "Tax", value: "tax" },
  { label: "Advisory", value: "advisory" },
  { label: "Audit", value: "audit" },
  { label: "Payroll", value: "payroll" },
  { label: "Other", value: "other" },
]

export const DEFAULT_COUNTRY_CODES = [{ short_name: "US", code: "+1" }]

export async function fetchCountryCodes() {
  try {
    const { data } = await axios.get("/api/country-codes")
    return data.data
  } catch {
    return DEFAULT_COUNTRY_CODES
  }
}
